import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-file-icon',
    imports: [NgClass],
    templateUrl: './file-icon.component.html'
})
export class FileIconComponent {
	@Input() fileExtension!: string;
	@Input() fileMimeType!: string;

	get fileIconClass() {
		// Determina l'estensione usando fileExtension o fileMimeType
		const extension = this.fileExtension || this.getFileExtensionFromType(this.fileMimeType);

		// Scegli la classe dell'icona in base all'estensione
		switch (extension) {
			case 'pdf':
				return 'qai-icon_pdf';
			case 'doc':
			case 'docx':
				return 'qai-icon_doc';
			case 'ppt':
			case 'pptx':
				return 'qai-icon_ppt';
			// case 'jpg':
			// case 'png':
			// case 'gif':
			// 	return 'qai-icon_image';
			// case 'txt':
			// 	return 'qai-icon_txt';
			// case 'xls':
			// case 'xlsx':
			// 	return 'qai-icon_excel';
			default:
				return 'qai-icon_file';
		}
	}

	private getFileExtensionFromType(mimeType: string): string {
		const mimeToExtensionMap: { [key: string]: string } = {
			'image/jpeg': 'jpg',
			'image/png': 'png',
			'image/gif': 'gif',
			'application/pdf': 'pdf',
			'text/plain': 'txt',
			'application/msword': 'doc',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
			'application/vnd.ms-excel': 'xls',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
			// Aggiungi altri tipi MIME e le loro estensioni se necessario
		};

		return mimeToExtensionMap[mimeType] || 'unknown';
	}
}
